import { inject, Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';
import {
  ANALYSIS_CONFIGURATION_ID_QUERY_PARAM_KEY,
  ANALYSIS_FILTER_QUERY_PARAM_KEY,
  ANALYSIS_HIERARCHY_QUERY_PARAM_KEY,
  ANALYSIS_TABLE_FILTER_QUERY_PARAM_KEY,
  ANALYSIS_VERSION_ID_QUERY_PARAM_KEY,
} from 'demand-forecasting/store/router-state/router.selectors';

@Injectable({
  providedIn: 'root',
})
export class AnalysisNavigationService {
  private readonly router = inject(Router);

  setQueryParams(data: {
    versionId?: string | null;
    analysisConfigurationId?: string | null;
    hierarchy?: string[] | null;
    filter?: Record<string, string | number | boolean | null> | null;
    tableFilter?: string | null;
  }) {
    const queryParams: Params = {};

    if (data.versionId !== undefined) {
      queryParams[ANALYSIS_VERSION_ID_QUERY_PARAM_KEY] = data.versionId;
    }
    if (data.analysisConfigurationId !== undefined) {
      queryParams[ANALYSIS_CONFIGURATION_ID_QUERY_PARAM_KEY] =
        data.analysisConfigurationId;
    }

    if (data.hierarchy !== undefined) {
      queryParams[ANALYSIS_HIERARCHY_QUERY_PARAM_KEY] = data.hierarchy;
    }

    if (data.filter !== undefined) {
      queryParams[ANALYSIS_FILTER_QUERY_PARAM_KEY] = data.filter
        ? JSON.stringify(data.filter)
        : null;
    }

    if (data.tableFilter !== undefined) {
      queryParams[ANALYSIS_TABLE_FILTER_QUERY_PARAM_KEY] = data.tableFilter;
    }
    this.router.navigate([], {
      queryParams,
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }
}
